import { useEffect, useState } from "react";
import "./feed.css";
import Carousel from "react-multi-carousel-18";
import "react-multi-carousel-18/lib/styles.css";
import keyboardArrowLeftIcon from "../../assets/shapes_svg/education/arrowcarouselleft.svg";
import keyboardArrowRightIcon from "../../assets/shapes_svg/education/arrowcarouselright.svg";
import FeedComponent from "./FeedComponent";
import {
  getFeed,
  getFeedLike,
  deleteFeedLike,
  addRecentlyViewedFeed,
  getRecentlyViewedFeed,
  deleteRecentlyViewedFeed,
} from "../../apis/Feed";
import { ContainerBody } from "../../App";
import FeedRow from "../../components/FeedRow";
import recentlyViewed from "../../assets/shapes_svg/feed/Circ Icon.svg";
import favorite from "../../assets/shapes_svg/feed/Hearts.svg";
import ArticlePopup from "../../components/ArticlePopUp";
import { useInvalidateQuery } from "../../components/InvalidateQueryContext";
import { feedApiKey } from "../../apis/ApiKey/FeedApiKey";

const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
  const {
    carouselState: { currentSlide },
  } = rest;
  return (
    <div
      className="carousel-button-group"
      style={{
        position: "absolute",
        display: "flex",
        justifyContent: "space-between",
        width: "73%",
      }}
    >
      <img
        src={keyboardArrowLeftIcon}
        onClick={() => previous()}
        alt="Keyboard Arrow Left Icon"
      />
      <img
        src={keyboardArrowRightIcon}
        onClick={() => next()}
        alt="Keyboard Arrow Right Icon"
      />
    </div>
  );
};

const Feed = () => {
  const [feeds, setFeeds] = useState([]);
  const [feedsLike, setFeedsLike] = useState([]);
  const [chosen, setChosen] = useState();
  const [recentlyViewedFeeds, setRecentlyViewedFeeds] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState(null);

  const { triggerInvalidate, invalidateKey, resetKey } = useInvalidateQuery();
  const {
    createRecentlyViewedFeed,
    deleteFeedRecentlyViewed,
    createdLikedFeed,
    deleteLikedFeed,
  } = feedApiKey;

  const handleArticleClick = (feed) => {
    setSelectedArticle(feed);
  };
  const closePopup = () => {
    setSelectedArticle(null);
  };

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  useEffect(() => {
    getFeed({
      setFeeds: setFeeds,
    });
    getFeedLike({
      setFeedsLike: setFeedsLike,
    });
    getRecentlyViewedFeed({
      setRecentlyViewedFeeds: setRecentlyViewedFeeds,
    });
  }, []);

  useEffect(() => {
    if (
      invalidateKey === createRecentlyViewedFeed ||
      invalidateKey === deleteFeedRecentlyViewed
    ) {
      getRecentlyViewedFeed({ setRecentlyViewedFeeds: setRecentlyViewedFeeds });
    }
    resetKey();
  }, [
    createRecentlyViewedFeed,
    deleteFeedRecentlyViewed,
    invalidateKey,
    resetKey,
  ]);

  useEffect(() => {
    if (
      invalidateKey === deleteLikedFeed ||
      invalidateKey === createdLikedFeed
    ) {
      getFeedLike({
        setFeedsLike: setFeedsLike,
      });
    }
    resetKey();
  }, [deleteLikedFeed, createdLikedFeed, invalidateKey, resetKey]);

  const likedFeedsLists = feedsLike.map((feed) => feed.id);

  const handleDeleteFeedLike = (feedId) => {
    deleteFeedLike({ id: feedId, triggerInvalidate: triggerInvalidate });
  };

  const handleRemoveChosen = () => {
    setChosen(null);
  };

  const handleDeleteRecentlyViewedFeed = (feedId) => {
    deleteRecentlyViewedFeed({
      id: feedId,
      triggerInvalidate: triggerInvalidate,
    });
  };

  const handleAddRecentlyViewedFeed = (feedId) => {
    addRecentlyViewedFeed({
      feed_id: feedId,
      triggerInvalidate: triggerInvalidate,
    });
  };

  return (
    <ContainerBody className="feed__main">
      <div className="feed__info__label ms-2">
        <h6>News Feed</h6>
      </div>
      <div className="feed__body d-flex align-items-center justify-content-center">
        <div className="w-100 d-flex align-items-center justify-content-center">
          <Carousel
            swipeable={false}
            draggable={false}
            showDots={false}
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            infinite={true}
            autoPlay={"mobile" !== "mobile" ? true : false}
            autoPlaySpeed={1000}
            arrows={false}
            customButtonGroup={<ButtonGroup />}
            renderButtonGroupOutside={true}
            keyBoardControl={true}
            transitionDuration={100}
            containerClass="carousel-container"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            deviceType={"desktop"}
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
          >
            {feeds && feeds.length >= 1
              ? feeds.map((feed, i) => {
                  return (
                    <FeedComponent
                      click={() => {
                        setChosen(feeds[i]);
                        handleAddRecentlyViewedFeed(feeds[i].id);
                      }}
                      feed={feed}
                      chosen={chosen ? feeds[i].title === chosen.title : false}
                      likedFeedsLists={likedFeedsLists}
                    />
                  );
                })
              : [<>No feeds here</>]}
          </Carousel>
        </div>
        {chosen ? (
          <div className="w-95 d-flex align-items-start justify-content-start">
            <div className="d-flex mb-2">
              <div className="d-flex w-50">
                <FeedComponent
                  click={() => {
                    handleArticleClick(chosen);
                  }}
                  feed={chosen}
                  likedFeedsLists={likedFeedsLists}
                  isChosen={true}
                  handleRemoveChosen={handleRemoveChosen}
                />
              </div>
              <div className="w-100 feed__main p-4">
                <div className="feed__wrapper">
                  <h4
                    className="px-4 py-2"
                    style={{
                      width: "fit-content",
                      fontSize: "14px",
                      color: "#F2F8F0",
                    }}
                  >
                    Page View
                  </h4>
                </div>
                <h5
                  className="mt-2"
                  style={{
                    color: "#F2F8F0",
                    wordBreak: "break-word",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={() => {
                    handleArticleClick(chosen);
                  }}
                >
                  {/* {chosen.link} */}
                  View here
                </h5>
                <div className="feed__wrapper mt-5">
                  <h4
                    className="px-4 py-2"
                    style={{
                      width: "fit-content",
                      fontSize: "14px",
                      color: "#F2F8F0",
                    }}
                  >
                    Summary
                  </h4>
                </div>
                <div
                  className="mt-2"
                  style={{
                    maxHeight: "500px",
                    overflowY: "scroll",
                    color: "#F2F8F0",
                    whiteSpace: "break-spaces",
                  }}
                >
                  <h5>{chosen.summary}</h5>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <div className="feed__info__label ms-2">
        <h6>Your Feed</h6>
      </div>
      <div className="feed__body d-flex flex-column ps-5">
        <FeedRow
          title={"Recently Viewed"}
          feeds={recentlyViewedFeeds}
          handleDelete={handleDeleteRecentlyViewedFeed}
          feedsLike={likedFeedsLists}
          src={recentlyViewed}
        />
        <FeedRow
          title={"Favorites"}
          feeds={feedsLike}
          handleDelete={handleDeleteFeedLike}
          feedsLike={likedFeedsLists}
          src={favorite}
        />
      </div>
      <ArticlePopup article={selectedArticle} onClose={closePopup} />
    </ContainerBody>
  );
};

export default Feed;
